import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "Landing Registration Resend Activation";
const server = null;
const service = null;
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    account: {
      api: {
        headers: {
          'Content-Type': 'application/json',
          'moduleCode': setup.setup.thor.moduleCode,
        },
        endpoints: {
          activation: {
           
            url: setup.setup.api.countdown_v1.url[environment] + '/members/activation',
            method: 'POST'
          }
        }
      }
    }
  },
  routes: {
    label: "Registration Resend Activation",
    prefix: "/u/landing-registration-activation/:token"
  },
  setup,
  environment
}

export default config;
